// @flow

import adaptFunction from '../adapt-function';

const adaptFacet = (facet: FacetWithConfig) => {
  const facetWithDisplayName = {
    ...facet,
    displayName: facet.localizedName,
  };
  
  return adaptFunction(facet.name)(facetWithDisplayName);
};

export default adaptFacet;
